<template>
  <button
    type="submit"
    :class="buttonStyle({ fontMode: props.fontMode, isTransparent: props.isTransparent, isWhiteColor: props.isWhiteColor, isBlackColor: props.isBlackColor, disabled: props.disabled })"
    :disabled="props.disabled"
    @click.prevent="props.onClick"
  >
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
import { tv } from 'tailwind-variants';

interface Props {
  disabled?: boolean;
  onClick: () => void;
  isWhiteColor?: boolean;
  isBlackColor?: boolean;
  fontMode?: 'jp' | 'en';
  minWidth?: number;
  isTransparent?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  isWhiteColor: false,
  isBlackColor: false,
  fontMode: 'jp',
  minWidth: 220,
  isTransparent: false,
});

const buttonStyle = tv({
  base: `h-8 rounded-[1px] min-w-[${props.minWidth}px] min-h-[40px] cursor-pointer self-center break-keep border border-solid border-gold1 bg-white px-4 py-0 text-base text-gold1 transition-all duration-300 ease-linear hover:border-opacity-50 hover:text-opacity-50 focus:outline-none`,
  variants: {
    fontMode: {
      jp: '',
      en: 'font-Spectral',
    },
    isTransparent: {
      true: 'bg-transparent',
    },
    isWhiteColor: {
      true: 'border-white text-white',
    },
    isBlackColor: {
      true: 'border-black text-black',
    },
    disabled: {
      true: 'cursor-default border-gray2 bg-gray1 text-gray2 hover:border-gray2 hover:border-opacity-100 hover:bg-gray1 hover:text-gray2 hover:text-opacity-100',
    },
  },
});
</script>
